var YouLi = YouLi ? YouLi : {};
YouLi.TripDates = YouLi.TripDates ? YouLi.TripDates : {};

(function (YouLi) {
    (function (TripDates) {


        function UpdateEndDate() {

            let startDate = $('.datepicker', '#TripDatesStartDate').data("DateTimePicker");
            let endDate = $('.datepicker', '#TripDatesEndDate').data("DateTimePicker");
            //set the date values based on the other one
            if (startDate && endDate) {
                if (startDate.date() != null) {
                    if ($('#TripDates_EndDate').val() == "" || endDate.date() == null || Date.parse(startDate.date()) > Date.parse(endDate.date())) {
                        endDate.date(startDate.date());
                    }
                }
            }
        }



        YouLi.TripDates.Initialise = function () {
            $(document).off("dp.show", "#TripDatesEndDate");
            $(document).on("dp.show", "#TripDatesEndDate", function (e) {
                // YOULI-459 - default the initial month
                datePicker = $('.datepicker', '#TripDatesEndDate').data("DateTimePicker");
                if (datePicker.date() == null) {
                    if ($("#TripDates_StartDate").val() != "") {
                        datePicker.date($("#TripDates_StartDate").val());
                    }
                    datePicker.date(null);
                }
            });



            $(document).on("dp.change", "#TripDatesEndDate", function () {
                UpdateEndDate()
                ToggleEstimatedDateFields();
            });

            $(document).on("dp.change", "#TripDatesStartDate", function () {
                UpdateEndDate()
                ToggleEstimatedDateFields();
            });

            $(document).off('click', "#toggle-date-estimate").on("click", "#toggle-date-estimate", function () {

                // toggle selection mode
                $("#TripDates_DateSelectionMode").val($("#TripDates_DateSelectionMode").val() == "exact" ? "approx" : "exact");

                ToggleEstimatedDateFields();

                YouLi.CreateEditTrip.SearchPrePostTrips();
            });
            ToggleEstimatedDateFields(true); //init

            $(document).on("change", "#TripDates_IsSingleDay", function () {

                var hasTime = $('#TripDates_IsSingleDay').is(":checked");
                $('.time-section').toggleClass('hidden', !hasTime);

            });

            $("#TripDatesStartTime").on("dp.change", ".timepicker", function (e) {

                let startTime = $('.timepicker', '#TripDatesStartTime').data("DateTimePicker");
                let endTime = $('.timepicker', '#TripDatesEndTime').data("DateTimePicker");

                if (startTime && endTime) {
                    if (startTime.date() !== null && endTime.date() === null) {
                        endTime.date(startTime.date());
                    }
                }
            });

        }

         function ToggleEstimatedDateFields(isInit) {
            var selectionMode = $("#TripDates_DateSelectionMode").val();

            if (!isInit)
                $("#pendingSaveSpan").show();

            if (selectionMode == "exact") {
                // show exact
                $(".exactDate").show();
                $("#approxDate").hide();
                $("#toggle-dateType-text").text("Not sure? Switch to enter free text");
                
                // Reminders: only show "ON" if the trip is considered active (see https://docs.google.com/spreadsheets/d/1DEIvcV95Rv3LdyFNvBUmQV5CRrapGtpRhYNzVOJVS3I/edit#gid=0).
                var endDate = moment($("#TripDates_EndDate").val(), "D MMM YYYY");
                var dateNow = new moment();
                if (!endDate || !endDate.isValid()) {
                    $("#auto-reminders-status").text("OFF");
                    $(".reminders-status a").attr("data-original-title", "Automated reminders OFF for this trip. Set a Start and End date to turn ON.");
                }
                else if (endDate < new moment().subtract(1, 'month')) {
                    $("#auto-reminders-status").text("OFF");
                    $(".reminders-status a").attr("data-original-title", "Automated reminders OFF for this trip because it is more than one month ago.");
                
                }
                else {
                    $("#auto-reminders-status").text("ON");
                    $(".reminders-status a").attr("data-original-title", "Automated reminders are ON for this trip. Click 'Don't know dates yet?' to turn OFF.");
                }
            }
            else {
                // show approx
                $(".exactDate").hide();
                $("#approxDate").show();
                $("#toggle-dateType-text").text("Ready to Go? Switch to Set your Dates");

                $("#auto-reminders-status").text("OFF");
                $(".reminders-status a").attr("data-original-title", "Automated reminders OFF for this trip. Click 'I know the trip dates' to set dates and turn ON.");
            }
        }


    }(YouLi.TripDates ? YouLi.TripDates : {}));
}(YouLi ? YouLi : {}));
